export function cleanDisplayName(name) {
  if (!name || typeof name !== "string") {
    return "";
  }
  return name
    .replace(/\bundefined\b/gi, "")
    .replace(/\bnull\b/gi, "")
    .replace(/\s+/g, " ")
    .trim();
}

export function isProfileComplete(user) {
  const username = typeof user?.username === "string" ? user.username.trim() : "";
  return Boolean(username) && username.toLowerCase() !== "undefined";
}
